export default __webpack_public_path__ + "static/media/closeIcon.a97e93c7.svg";